import './application.js'
import '../stylesheets/web_app.scss'
import TurbolinksAdapter from 'vue-turbolinks'
import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex';
import {mapState} from 'vuex';
import {mapGetters} from 'vuex';

Vue.use(Vuex);

import store from '../store/web_app_store'
import MapComponent from '../map-component.vue'

import axios from 'axios'
import VueAxiosPlugin from './plugins/vue-axios'
import IznvOpeningHours from './plugins/iznv-opening-hours.js'
import IznvSound from './plugins/iznv-sound'

import  L from 'leaflet'
// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';

Vue.use(require('vue-moment'));

Vue.use(VueAxiosPlugin, { axios: axios })

Vue.use(TurbolinksAdapter)

// import { BootstrapVue } from 'bootstrap-vue'
// Vue.use(BootstrapVue)
// import bootstrap from "bootstrap"
import { Carousel, Modal, Collapse} from "bootstrap"

document.addEventListener('turbolinks:load', () => {
  const app = new Vue({
    el: '#app',
    store,
    components: { MapComponent },
    data: () => {
      return {
        displayOptions: {
          show_next_checkpoint: true,
          show_transportation: true,
          course_achievement_display: 'dot',
          disable_sound: true,
        },
        audioContext: new AudioContext(),
        osc: null,
        routineTimer: null,
        openingStateChanged: false,
        checkPointNextOpenTimeStringChanged: false,
        eventMessageKey: "",
        counter: 0,
        map: null,
        currentLocation: null,
        currentLocationRefreshed: false,
        globalAppData: {},
        userData: {},
        seriesData: {
          id: '',
          name: '',
          url: '',
          home_url: '',
          course_index_url: '',
          menu_links: [],
        },
        courses: [],
        destinationsCount: 0,
        stateUpdate: 0,
        courseIndex: 1,
        checkPointIndex: 1,
        urlParams: {
          checkPointId: 0,
        },
        navbarCollapseMenu: null,
        checkPointCarousel: null,
        currentCheckPointIndex: -1,
        doNotFirecheckPointSelected: false,
        recordVisitButtonText: '訪問を記録',
        externalPageUrl: '',
        visitRecordFormModal: null,
        checkPointToRecord: null,
        visitRecordTime: new Date(),
        visitRecordFormComment: '',
        visitRecordFormRating: 0,
        destinationDistanceThreshold: 500,
        visitRecordGpsConfirmed: true,
        visitRecordModal: null,
        visitRecordItemModal: null,
        visitRecordCheckPoint: null,
        visitRecordShownVisitIndex: 0,
        editVisitRecordFormModal: null,
        visitRecordToEdit: null,
        visitRecordToEditCheckPoint: null,
        dateFormat: 'YYYY年M月D日',
        dateTimeFormat: 'YYYY年M月D日 H時m分',
        dayViewHeaderFormat: 'YYYY年M月',
        editVisitRecordForm: {
          id: 0,
          comment: '',
          date: new Date(),
          gps_confirmed: true,
          rating: 0,
        },
        userProfileModal: null,
        editUserProfileModal: null,
        userProfileForm: {
          name: '',
          gender: '',
          birth_month: null,
          area_of_residence: '',
        },
        defaultBirthYear: 2000,
        birthYearOptions: [],
        user_name_unique_checked: false,
        user_name_unique: true,
      }
    },
    computed: {
      currentLocationDistance: function() {
        this.currentLocationRefreshed;
        this.currentLocationRefreshed = false;
        console.log('currentLocationDistance selectedCheckPoint: ', this.$store.state.selectedCheckPoint);
        const selectedCheckPoint = this.$store.state.selectedCheckPoint;
        if(!selectedCheckPoint || selectedCheckPoint.check_point_type !== 'destination' || !this.currentLocation) return null;
        const distance = this.locationDistance(this.currentLocation, selectedCheckPoint.location.geometry);
        if(distance > this.destinationDistanceThreshold) {
          const distanceString = '最後に確認した位置から';
          if(distance > 100000) return distanceString + '約' + Math.round(distance / 1000) + 'km';
          else if(distance > 1000) return distanceString + '約' + (distance / 1000.0).toFixed(1) + 'km';
          else if(distance > 0) return distanceString + '約' + distance + 'm';
        } else {
          // alert('近くにいます！');
          // IznvSound.beep01(this.audioContext.destination, this.audioContext.currentTime);
          return '近くにいます';
        }
      },
      selectedCourse: {
        get: function() { this.stateUpdate--; return this.$store.state.selectedCourse; },
        set: function(value) {
          this.$store.commit('setSelectedCourse', value); 
          const index = this.courses.findIndex(course => course === value) + 1;
          this.setCookieCourseIndex(index);
          this.startRoutine(false);
          this.checkCourseMarksOpen(value);
          this.startRoutine();
        },
      },
      checkPointNextOpenTime: function() {
        this.checkPointNextOpenTimeStringChanged;
        this.checkPointNextOpenTimeStringChanged = false;
        console.log('checkPointNextOpenTime called. selectedCheckPoint: ', this.$store.state.selectedCheckPoint);
        this.checkPointNextOpenTimeStringChanged = false;
        if(this.$store.state.selectedCheckPoint && this.$store.state.selectedCheckPoint.mark.nextOpenTimeString) {
          const mark = this.$store.state.selectedCheckPoint.mark;
          return {
            isClosed: mark.isClosed,
            nextOpenTimeString: mark.nextOpenTimeString,
            changed: this.checkPointNextOpenTimeStringChanged,
          };
        } else return false;
      },
      destinationsCompletedCount: function() {
        return this.courses.map(course => course.checkPoints).flat(1).filter(checkPoint => checkPoint.visits.length).length;
      },
      modals: function() {
        return [
          this.visitRecordModal,
          this.visitRecordFormModal,
          this.visitRecordItemModal,
          this.editVisitRecordFormModal
        ];
      },
      recordVisitParams: function() {
        return {
          course_mark_id: this.checkPointToRecord?.id,
          gps_confirmed: this.visitRecordGpsConfirmed,
          comment: this.visitRecordFormComment,
          date: this.$moment(this.visitRecordTime).format(),
          rating: this.visitRecordFormRating,
        };
      },
      previousVisitRecordCheckPoint: function() {
        if(!this.visitRecordCheckPoint) return null;
        const pointsArray = this.visitRecordCheckPoint.course.destinationPoints;
        const currentIndex = pointsArray.indexOf(this.visitRecordCheckPoint);
        if(currentIndex > 0) return pointsArray[currentIndex - 1];
        const courseIndex = this.courses.indexOf(this.visitRecordCheckPoint.course);
        if(courseIndex > 0) return this.courses[courseIndex - 1].destinationPoints.slice(-1)[0];
        return null;
      },
      nextVisitRecordCheckPoint: function() {
        if(!this.visitRecordCheckPoint) return null;
        const pointsArray = this.visitRecordCheckPoint.course.destinationPoints;
        const currentIndex = pointsArray.indexOf(this.visitRecordCheckPoint);
        if(currentIndex >= 0 && pointsArray.length >= currentIndex + 2) return pointsArray[currentIndex + 1];
        const courseIndex = this.courses.indexOf(this.visitRecordCheckPoint.course);
        if(courseIndex >= 0 && this.courses.length >= courseIndex + 2) return this.courses[courseIndex + 1].destinationPoints[0];
        return null;
      },
      editVisitRecordFormDateString: {
        get() { return this.$moment(this.editVisitRecordForm.date).format(this.dateTimeFormat); },
        set(value) {
          this.editVisitRecordForm.date = this.$moment(value).format();
        }
      },
      userProfileBirthYearSelect: {
        get() {
          if(!this.userProfileForm.birth_month) return '0';
          return this.$moment(this.userProfileForm.birth_month).format('YYYY');
        },
        set(value) {
          if(value < 1) this.userProfileForm.birth_month = null;
          this.userProfileForm.birth_month = this.$moment(value + '-' + (+this.userProfileBirthMonthSelect || 1), 'YYYY-M').format();
        },
      },
      userProfileBirthMonthSelect: {
        get() {
          if(!this.userProfileForm.birth_month) return '0';
          return this.$moment(this.userProfileForm.birth_month).format('M');
        },
        set(value) {
          if(value < 1) this.userProfileForm.birth_month = null;
          else this.userProfileForm.birth_month = this.$moment((+this.userProfileBirthYearSelect || this.defaultBirthYear) + '-' + value, 'YYYY-M').format();
        },
      },
      userProfileBirthMonthIsFuture: function() {
        return this.userProfileForm.birth_month && this.$moment(this.userProfileForm.birth_month).isAfter();
      },
      name_unique_text: function() {
        if(!this.user_name_unique_checked) return "";
        if(this.user_name_unique) return "使用できます。";
        return "このニックネームは使用できません。";
      }
    },
    filters: {
      newLineToBr: function(text) {
        return text.replaceAll(/\n/g, '<br>');
      },
    },
    methods: {
      iznvBeep: function() {
        const ctx = this.audioContext;
        console.log('iznvBeep ctx: ', ctx);
        const osc = ctx.createOscillator();
        osc.frequency.value = 440;
        osc.connect(ctx.destination);
        osc.start();
        setTimeout(() => {
          osc.stop();
        }, 100);
        IznvSound.beep01(ctx.destination, ctx.currentTime);
      },
      startRoutine: function(start = true) {
        if(this.routineTimer) clearTimeout(this.routineTimer);
        if(start) {
          this.execRoutine(true);
          setTimeout(this.execRoutine, 20000);
        }
      },
      execRoutine: function(once = false) {
        this.checkCourseMarksOpen();
        if(!once) this.startRoutine();
      },
      reloadWebApp: function() {
        if(this.userData.email) location.replace(location.origin + location.pathname + '?login=1');
        else location.replace(location.origin + location.pathname);
      },
      setWaiting: function(waiting = true) {
        if(waiting) $('body').removeClass('loaded');
        else {
          $('body').addClass('loaded');
        }
      },
      fire: function(eventName, attributes) {
        $('#app').trigger(eventName, attributes);
      },
      currentLocationChecked: function(...args) {
        const [location, callback] = args;
        this.currentLocation = location;
        this.currentLocationRefreshed = true;
        console.log('currentLocationChecked currentLocation: ', this.currentLocation);
        if(callback) callback(location);
      },
      start: function() {
        // alert('app started!');
        this.fire('appStateLoaded');
      },
      initEventAction: function() {
        $('#courseHeaderCarousel').on('slide.bs.carousel', (e) => {
          console.log('slide.bs.carousel triggered. from: ' + e.from + ' to: ' + e.to + ' target.id: ' + e.relatedTarget.dataset.courseId);
          this.switchCourse(e.relatedTarget.dataset.courseId);
        })
        // .on('slid.bs.carousel', () => this.fire('requestResetMapSize'))
        ;
        // const checkPointCarousel = document.querySelector('#checkPointCarousel');
        // this.checkPointCarousel = Carousel.getInstance(checkPointCarousel);
        // this.checkPointCarousel = new Carousel(checkPointCarousel, {
        //   interval: false,
        // });
        $('#checkPointCarousel').on('slide.bs.carousel', (e) => {
          const checkPoint = this.selectedCourse.checkPoints.find(c => c.id === e.relatedTarget.dataset.checkPointId);
          if(checkPoint) this.selectCheckPoint(checkPoint);
        }).on('slid.bs.carousel', () => this.fire('requestResetMapSize'));
      },
      hideModals: function(activeModal = null) {
        this.modals.forEach(modal => {
          if(modal && modal !== activeModal) modal.hide();
        });
      },
      sortVisitRecords: function(checkPoint) {

      },
      loadAppData: async function() {
        try {
          //ブラウザ再起動時にコースが読み込めない対策
          // console.log('axios.defaults.headers.common: ', axios.defaults.headers.common);
          // console.log('csrf_token: ', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
          // const csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          // axios.defaults.headers.common = {
          //     "X-Requested-With": "XMLHttpRequest",
          //     "X-CSRF-Token": csrf_token,
          // }

          const res = await axios.post('/data/app');
          console.log('loadAppData res: ', res);
          if(res.data.status !== 'SUCCESS') throw new Error(res.data.message);
          // localStorage.setItem('courseDataReloading', '');
          this.seriesData = {
            id: res.data.data.id,
            name: res.data.data.name,
            url: res.data.data.url,
            home_url: res.data.data.home_url,
            course_index_url: res.data.data.course_index_url,
            menu_links: res.data.data.menu_links,
          };
          this.courses = res.data.data.courses;
          if(this.courses.length) {
            this.courses.forEach(course => {
              course.checkPoints = [];
              course.destinationPoints = [];
              course.course_marks.forEach((course_mark, index) => {
                course_mark.course = course;
                course_mark.mark = course_mark.mark_data;
                course_mark.mark_visits = [];
                course_mark.location_visits = [];
                course_mark.visits = course_mark.location_visits;//訪問済みを場所で判定
                // course_mark.visits = course_mark.mark_visits;
                course_mark.nextCheckPoint = course.course_marks[index + 1] || null;
                if(course_mark.check_point_type === 'destination') course.destinationPoints.push(course_mark);
                course.checkPoints.push(course_mark);
              });
              if(this.userData.visit_records) {
                this.userData.visit_records.forEach(record => {
                  course.checkPoints.filter(checkPoint => checkPoint.location.id === record.location_id).forEach(checkPoint => {
                    record.rating = record.info?.rating || 0;
                    checkPoint.location_visits.push(record);
                    if(checkPoint.mark.id === record.mark_id) checkPoint.mark_visits.push(record);
                  });
                  // course.checkPoints.filter(checkPoint => checkPoint.mark.id === record.mark_id).forEach(checkPoint => {
                  //   record.rating = record.info?.rating || 0;
                  //   checkPoint.visits.push(record);
                  // });
                });
              }
              this.destinationsCount += course.destinationPoints.length;
              console.log('destinationsCount: ', this.destinationsCount);
              course.checkPoints.forEach(checkPoint => {
                this.$store.commit('sortVisits', checkPoint.visits);
              });
            });
            console.log('loadAppData courses:', this.courses);
            const index = this.courses.length > this.courseIndex ? this.courseIndex - 1 : this.courses.length - 1;
            this.selectedCourse = this.courses[index];
            this.courseIndex = index + 1;
            this.stateUpdate++;
          }
        } catch(e) {
          console.error(e);
          const isReloading = localStorage.getItem('courseDataReloading');
          if(isReloading) {
            alert('コースデータが読み込めませんでした。');
            localStorage.setItem('courseDataReloading', '');
          } else {
            localStorage.setItem('courseDataReloading', 'true');
            this.reloadWebApp();
          }
        } finally {
          this.initEventAction();
          this.checkDataReady();
        }
      },
      switchCourse: function(courseId) {
        this.selectedCourse = this.courses.find(course => course.id === courseId);
        this.stateUpdate++;
        console.log('switchCourse this.selectedCourse: ', this.selectedCourse.name);
        this.$store.commit('setSelectedCheckPoint', null);
        this.loadCourseState();
      },
      loadCourseState: function() {
        const checkPointId = this.urlParams.checkPointId;
        let checkPointIndex = (this.selectedCourse?.checkPoints?.findIndex(checkPoint => checkPoint.id === checkPointId) || -1) + 1;
        if(checkPointIndex < 1) checkPointIndex = 1;
        this.checkPointIndex = checkPointIndex;
        console.log('loadCourseState checkPointIndex: ', checkPointIndex);
        const state = {
          courseState: {
            checkPointIndex: this.checkPointIndex,
          }
        };
        this.setCourseState(state);
        this.urlParams.checkPointId = 0;

        // if(this.checkPointIndex > 0) {
        //   if(this.selectedCourse.checkPoints.length >= this.checkPointIndex) {
        //     const state = {
        //       courseState: {
        //         checkPointIndex: this.checkPointIndex,
        //       }
        //     };
        //     this.setCourseState(state);
        //   }
        //   this.checkPointIndex = 0;
        // }

        const courseState = this.getCourseState();
        console.log('loadCourseState courseState: ', courseState);
        const index = courseState.courseState?.checkPointIndex || 1;
        const selectedCheckPoint = index ? this.selectedCourse.checkPoints.find(cp => cp.order === index) : null;
        console.log('loadCourseState selectedCheckPoint, index: ', selectedCheckPoint, index);
        this.$nextTick(() => {
          if(selectedCheckPoint) this.setCheckPointNavigation(selectedCheckPoint, false);
          else this.$store.commit('setSelectedCheckPoint', selectedCheckPoint);
          this.fire('courseSet', courseState.mapState);
        });
      },
      checkCourseMarksOpen: function(course = null) {
        if(!course) course = this.selectedCourse;
        course.checkPoints.forEach(checkPoint => {
          this.checkOpeningHour(checkPoint);
        });
        if(this.openingStateChanged) {
          this.fire('updateMarkerState');
          this.openingStateChanged = false;
        }
        if(this.checkPointNextOpenTimeStringChanged) {
          console.log('checkPointNextOpenTimeStringChanged is true!');
          this.checkPointNextOpenTimeStringChanged = false;
        }
      },
      checkDataReady: function() {
        this.$store.commit('setDataReady');
        this.loadCourseState();
      },
      mapGotReady: function() {
        this.appGotReady();
      },
      appGotReady: function() {
        this.setWaiting(false);
      },
      setRecordVisitButtonText: function(checkPoint) {
        if(checkPoint.check_point_type === 'destination' && checkPoint.visits.length > 0) {
          this.recordVisitButtonText = `訪問をもう1度記録（${checkPoint.visits.length}回訪問済み）`;
        }
        else this.recordVisitButtonText = '訪問を記録';
      },
      setCheckPointNavigation: function(checkPoint, fire = true) {
        this.doNotFirecheckPointSelected = !fire;
        this.setRecordVisitButtonText(checkPoint);
        const checkPointCarousel = document.querySelector('#checkPointCarousel');
        const instance = new Carousel(checkPointCarousel);
        instance.to(checkPoint.order - 1);
        //console.log('setCheckPointNavigation carousel instance, order: ', Carousel.getInstance(checkPointCarousel), checkPoint.order);
        if(!this.$store.state.selectedCheckPoint || this.$store.state.selectedCheckPoint.order === checkPoint.order) this.selectCheckPoint(checkPoint, fire);
        /*
        if(this.counter++ > 100) return;
      // this.$nextTick(() => {
        console.log('setCheckPointNavigation counter, fire: ', this.counter, fire);
        const checkPointCarousel = document.querySelector('#checkPointCarousel');
        console.log('setCheckPointNavigation element: ', checkPointCarousel);
        console.log('setCheckPointNavigation Carousel.getInstance: ', Carousel.getInstance(checkPointCarousel));
        const instance = new Carousel(checkPointCarousel);
        //const instance = Carousel.getInstance(checkPointCarousel);
        if(instance) {
          Carousel.getInstance(checkPointCarousel).to(checkPoint.order - 1);
          console.log('setCheckPointNavigation carousel instance, order: ', Carousel.getInstance(checkPointCarousel), checkPoint.order);
          // console.log('setCheckPointNavigation carousel instance: ', this.checkPointCarousel);
          // this.checkPointCarousel.to(checkPoint.order - 1);
          if(!this.$store.state.selectedCheckPoint || this.$store.state.selectedCheckPoint.order === checkPoint.order) this.selectCheckPoint(checkPoint, fire);
        } else {
          setTimeout(() => {
            this.setCheckPointNavigation(checkPoint, fire);
          }, 100);
        }
        // });
        */
      },
      selectCheckPoint: function(checkPoint, fire = true) {
        this.currentCheckPointIndex = checkPoint ? checkPoint.order : -1;
        this.setRecordVisitButtonText(checkPoint);
        this.$store.commit('setSelectedCheckPoint', checkPoint);
        this.courseStateChanged();
        this.checkPointNextOpenTimeStringChanged = true;
        this.currentLocationRefreshed = true;
        const setCenter = !this.doNotFirecheckPointSelected && fire;
        console.log('selectCheckPoint checkPoint, setCenter: ', checkPoint, setCenter);
        this.fire('checkPointSelected', setCenter);
        this.doNotFirecheckPointSelected = false;
        // this.startRoutine();
      },
      destinationPoints: function(course) {
        return course.checkPoints.filter(checkPoint => checkPoint.check_point_type === 'destination');
      },
      courseDestinationsCompletedCount: function(course) {
        if(!course) return 0;
        return course.checkPoints.filter(checkPoint => checkPoint.visits.length).length;
      },
      nextCheckPoint: function(checkPoint) {
        const checkPoints = this.$store.getters.checkPoints;
        const index = checkPoints.findIndex(c => c === checkPoint);
        return checkPoints[index + 1] || null;
      },
      nextCheckPointName: function(checkPoint) {
        const nextCheckPoint = this.nextCheckPoint(checkPoint);
        return nextCheckPoint ? nextCheckPoint.mark_data.name : 'なし';
      },
      transportationName: function(checkPoint) {
        switch (checkPoint.info.transportation) {
          case 'foot':
            return '徒歩';
            break;
          case 'bus':
            return 'バス';
            break;
          case 'train':
            return '電車';
            break;
          default:
            return '';
        }
      },
      checkPointHasBusinessProperty: function(checkPoint) {
        const properties = checkPoint.mark.business_properties;
        return properties && ((properties.opening_hours && properties.opening_hours.length) || (properties.busines_days && properties.business_days.length));
      },
      checkPointBusinessPropertyString: function(checkPoint) {
        const properties = checkPoint.mark.business_properties;
        // const nextOpenTimeString = '（<span>' + (checkPoint.mark.nextOpenTimeString || '') + '</span>）';
        // let html = checkPoint.mark.isClosed ? '<span class="text-muted">閉店中</span>' : '<span class="text-danger">開店中</span>';
        // html += '（' + IznvOpeningHours.stringHtml(properties.opening_hours, properties.business_days) + '<span>' + nextOpenTimeString + '</span>' + '）';
        // html += nextOpenTimeString;
        const html = IznvOpeningHours.stringHtml(properties.opening_hours, properties.business_days);
        return html;
      },
      checkOpeningHour: function(checkPoint) {
        if(!this.checkPointHasBusinessProperty(checkPoint)) return;
        const tempResult = (typeof checkPoint.mark.isClosed === 'undefined') ? -1 : checkPoint.mark.isClosed;
        const properties = checkPoint.mark.business_properties;
        // const tempResult = checkPoint.mark.isClosed;
        const isClosed = !IznvOpeningHours.checkOpen(properties.opening_hours, properties.business_days);
        this.$store.commit('setCheckPointIsClosed', {
          checkPoint: checkPoint,
          isClosed: isClosed,
        });
        // checkPoint.mark.isClosed = !IznvOpeningHours.checkOpen(properties.opening_hours, properties.business_days);
        // console.log('checkOpeningHour tempResult, checkPoint.mark.isClosed: ', tempResult, checkPoint.mark.isClosed);
        if(tempResult !== checkPoint.mark.isClosed) {
          this.$store.commit('setCheckPointNextOpenTime', {
            checkPoint: checkPoint,
            nextOpenTime: IznvOpeningHours.nextOpenTime(properties.opening_hours, properties.business_days, checkPoint.mark.isClosed),//次まで遠い場合（1週間以上）の時はfalseが返ってくる
          });
          this.openingStateChanged = true;
          // console.log(checkPoint.mark.nextOpenTime.format());
        }
        const tempNextOpenTimeString = checkPoint.mark.nextOpenTimeString;
        const newNextOpenTimeString = IznvOpeningHours.nextOpenTimeString(checkPoint.mark.nextOpenTime, checkPoint.mark.isClosed);
        if(tempNextOpenTimeString !== newNextOpenTimeString) {
          // console.log('checkOpeningHour nextOpenTimeString changed! temp, new: ', tempNextOpenTimeString, newNextOpenTimeString);
          this.$store.commit('setCheckPointNextOpenTimeString', {
            checkPoint: checkPoint,
            nextOpenTimeString: newNextOpenTimeString,
          });
          if(this.$store.state.selectedCheckPoint === checkPoint) this.checkPointNextOpenTimeStringChanged = true;
        }
      },
      setCookieCourseIndex: function(courseIndex = 1) {
        document.cookie = "course_index=" + courseIndex + "; max-age=" + (60 * 60 * 24 * 365);
        console.log('setCookieCourseIndex cookie: ', document.cookie);
      },
      setCookieCheckPointId: function(checkPointId = '') {
        document.cookie = "check_point_id=" + checkPointId + "; max-age=" + (60 * 60 * 24 * 365);
        console.log('setCookieCheckPointId cookie: ', document.cookie);
      },
      getCourseState: function() {
        const storedStateJson = localStorage.getItem(this.selectedCourse.id);
        return storedStateJson ? JSON.parse(storedStateJson) : {};
      },
      setCourseState: function(state) {
        const storedState = this.getCourseState();
        console.log('setCourseState selectedCourse, state: ', this.selectedCourse.name, state);
        localStorage.setItem(this.selectedCourse.id, JSON.stringify(Object.assign(storedState, state)));
      },
      mapStateChanged: function(mapState) {
        this.setCourseState({mapState: mapState});
      },
      courseStateChanged: function() {
        const selectedCheckPoint = this.$store.state.selectedCheckPoint;
        const state = {
          courseState: {
            checkPointIndex: selectedCheckPoint ? selectedCheckPoint.order : null,
          }
        };
        this.setCourseState(state);
      },
      collapseNaviBarMenu: function() {
        if(!this.navbarCollapseMenu) {
          this.navbarCollapseMenu = new Collapse(document.getElementById('navbarMain'), {
            keyboard: false
          });
        }
        this.navbarCollapseMenu.hide();
      },
      openAccommodationsLink: function() {
        this.openExternalPageModal(this.selectedCourse.accommodations_url);
      },
      openExternalPageModal: function(url) {
        this.externalPageUrl = url;
        const modal = new Modal(document.getElementById('externalPageModal'), {
          keyboard: false
        });
        //const myModalEl = document.getElementById('externalPageModal')
        //const modal = Modal.getInstance(myModalEl) // Returns a Bootstrap modal instance      
        modal.show();
        this.collapseNaviBarMenu();
        $('#externalPageModal').off('hide.bs.modal').on('hide.bs.modal', () => {
          this.collapseNaviBarMenu();
        });
        $('#externalPageModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
          console.log('externalPageModal closed.');
          this.externalPageUrl = '';
        });
      },
      locationDistance: function(location1, location2) {
        // return google.maps.geometry.spherical.computeDistanceBetween(location1, location2);
        return L.latLng(location1).distanceTo(location2);
      },
      openRecordFormModal: function(checkPoint) {
        this.fire('requestCurrentLocation', this.openRecordFormCallback);
        this.checkPointToRecord = checkPoint;
        this.setWaiting();
      },
      openRecordFormCallback: function(location) {
        console.log('openRecordFormCallback called. location: ', location);
        this.setWaiting(false);
        const distance = location ? this.locationDistance(location, this.checkPointToRecord.location.geometry) : -1;
        if(!location || distance > this.destinationDistanceThreshold) {
          let distanceString = '';
          if(distance > 100000) distanceString = '（約' + Math.round(distance / 1000) + 'km離れているようです）';
          else if(distance > 1000) distanceString = '（約' + (distance / 1000.0).toFixed(1) + 'km離れているようです）';
          else if(distance > 0) distanceString = '（約' + distance + 'm離れているようです）';
          if(!confirm(`ポイントの近くにいることが確認できませんでした${distanceString}。それでも訪問を記録しますか？`)) {
            this.checkPointToRecord = null;
            return;
          }
          this.visitRecordGpsConfirmed = false;
        } else {
          this.visitRecordGpsConfirmed = true;
        }
        this.visitRecordTime = new Date();
        console.log('openRecordFormModal checkPointToRecord: ', this.checkPointToRecord);
        if(!this.visitRecordFormModal) {
          this.visitRecordFormModal = new Modal(document.getElementById('recordFormModal'), {
            keyboard: false
          });
        }
        this.visitRecordFormModal.show();
        this.collapseNaviBarMenu();
        $('#recordFormModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
          console.log('recordFormModal closed.');
          this.checkPointToRecord = null;
          this.visitRecordFormComment = '';
          this.visitRecordFormRating = 0;
          this.collapseNaviBarMenu();
        });
      },
      closeRecordFormModal: function() {
        console.log('closeRecordFormModal called..');
        if(!this.visitRecordFormModal) {
          this.visitRecordFormModal = new Modal(document.getElementById('recordFormModal'), {
            keyboard: false
          });
        }
        this.visitRecordFormModal.hide();
        this.collapseNaviBarMenu();
      },
      recordVisit: async function() {
        console.log('recordVisit called. recordVisitParams: ', this.recordVisitParams);
        this.setWaiting();
        try {
          const res = await axios.post('/record_visit/', this.recordVisitParams);
          console.log('recordVisit res: ', res);
          if(res.data.status !== 'SUCCESS') throw new Error(res.data.message);
          if(!res.data.data.visit_record.id) throw new Error('visit_record did not saved.');
          alert('訪問記録を保存しました。');
          const newRecord = res.data.data.visit_record;
          newRecord.rating = newRecord.info?.rating || 0;
          this.userData.visit_records.push(newRecord);
          // this.checkPointToRecord.visits.push(newRecord);
          this.checkPointToRecord.mark_visits.push(newRecord);
          this.checkPointToRecord.location_visits.push(newRecord);
          this.courses.splice(0, 0);
          this.setRecordVisitButtonText(this.checkPointToRecord);
          this.closeRecordFormModal();
          console.log('recordVisit record saved. courses, newRecord: ', this.courses, newRecord);
        } catch(e) {
          console.error(e);
          alert('訪問記録の保存に失敗しました。');
          if(confirm('Webアプリを再読込するとうまくいくかもしれません。再読込しますか？（現在の入力内容は破棄されます）')) {
            this.reloadWebApp();
          }
        } finally {
          this.setWaiting(false);
        }
      },
      openVisitRecordModal: function() {
        if(!this.visitRecordModal) {
          this.visitRecordModal = new Modal(document.getElementById('visitRecordModal'), {
            keyboard: false
          });
          $('#visitRecordModal').off('shown.bs.modal').on('shown.bs.modal', () => {
            $('#visitRecordModal').removeClass('noTransition');
          });
        }
        this.visitRecordModal.show();
        this.collapseNaviBarMenu();
        $('#visitRecordModal').off('hide.bs.modal').on('hide.bs.modal', () => {
          this.collapseNaviBarMenu();
        });
        // $('#visitRecordModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
        // });
      },
      stampImage: function(checkPoint) {
        let imgSrc = '';
        if(checkPoint.visits.length) {
          imgSrc = checkPoint.visits.slice(-1)[0].stamp_url;
          if(!imgSrc || !imgSrc.length) imgSrc = checkPoint.stamp_url;
        }
        if(!imgSrc || !imgSrc.length) imgSrc = checkPoint.mark.category.icons.icon.url;
        return imgSrc;
      },
      showVisitRecordItem: function(checkPoint) {
        console.log("showVisitRecordItem called. checkPoint: ", checkPoint);
        this.visitRecordShownVisitIndex = checkPoint.visits.length - 1;
        this.visitRecordCheckPoint = checkPoint;
        if(!this.visitRecordModal) {
          this.visitRecordModal = new Modal(document.getElementById('visitRecordModal'), {
            keyboard: false
          });
        }
        if(!this.visitRecordItemModal) {
          this.visitRecordItemModal = new Modal(document.getElementById('visitRecordItemModal'), {
            keyboard: false
          });
          $('#visitRecordItemModal').off('shown.bs.modal').on('shown.bs.modal', () => {
            this.visitRecordModal.hide();
            $('#visitRecordItemModal').removeClass('noTransition');
          });
        }
        this.visitRecordItemModal.show();
        $('#visitRecordItemModal').off('hide.bs.modal').on('hide.bs.modal', () => {
          if($('#editRecordFormModal').is(':hidden')) {
            $('#visitRecordModal').addClass('noTransition');
            this.visitRecordModal.show();
          }
        });
      },
      setVisitRecordCheckPoint: function(checkPoint) {
        this.visitRecordShownVisitIndex = checkPoint.visits.length - 1;
        this.visitRecordCheckPoint = checkPoint;
      },
      clearEditVisitRecordForm: function() {
        this.editVisitRecordForm = {
          id: 0,
          comment: '',
          gps_confirmed: true,
          date: '',
          rating: 0,
        };
      },
      editVisitRecord: function(visitRecord, checkPoint) {
        // if(!confirm(`訪問記録を編集します。`)) return;
        this.visitRecordToEdit = visitRecord;
        this.visitRecordToEditCheckPoint = checkPoint;
        this.editVisitRecordForm.id = visitRecord.id;
        this.editVisitRecordForm.comment = visitRecord.comment;
        this.editVisitRecordForm.gps_confirmed = visitRecord.gps_confirmed;
        this.editVisitRecordForm.date = visitRecord.date;
        this.editVisitRecordForm.rating = visitRecord.rating;
        $('#visitRecordDateTimePicker').datetimepicker('options', {
          date: visitRecord.date,
          useCurrent: false,
          maxDate: this.$moment(),
          // defaultDate: this.$moment(visitRecord.date),
        });
        console.log('editVisitRecord datetimepicker options: ', $('#visitRecordDateTimePicker').datetimepicker('maxDate'));
        console.log('editVisitRecord called. this.visitRecordToEdit, this.visitRecordToEditCheckPoint: ', this.visitRecordToEdit, this.visitRecordToEditCheckPoint);
        if(!this.editVisitRecordFormModal) {
          this.editVisitRecordFormModal = new Modal(document.getElementById('editRecordFormModal'), {
            keyboard: false
          });
          $('#editRecordFormModal').off('shown.bs.modal').on('shown.bs.modal', () => {
            this.hideModals(this.editVisitRecordFormModal);
          });
        }
        this.editVisitRecordFormModal.show();
        $('#editRecordFormModal').off('hide.bs.modal').on('hide.bs.modal', () => {
          $('#visitRecordDateTimePicker').datetimepicker('hide');
          this.clearEditVisitRecordForm();
          $('#visitRecordItemModal').addClass('noTransition');
          this.visitRecordItemModal.show();
        });
      },
      closeEditRecordFormModal: function() {
        this.editVisitRecordFormModal.hide();
      },
      updateVisitRecord: async function() {
        console.log('updateVisitRecord called.');
        this.setWaiting();
        try {
          const res = await axios.put('/record_visit', this.editVisitRecordForm);
          console.log('updateVisitRecord res: ', res);
          // if(res.data.status !== 'SUCCESS') throw new Error(res.data.message);
          if(res.data.status !== 'SUCCESS') throw new Error(res.data.errors || res.data.message);
          alert('訪問記録を更新しました。');
          this.$store.commit('updateVisitRecord', {
            destRecord: this.visitRecordToEdit,
            sourceRecord: this.editVisitRecordForm,
          });
          this.$store.commit('sortVisits', this.visitRecordToEditCheckPoint.visits);
          this.courses.splice(0, 0);
        } catch(error) {
          alert('訪問記録を更新できませんでした。');
          console.error(error);
          if(confirm('Webアプリを再読込するとうまくいくかもしれません。再読込しますか？（現在の入力内容は破棄されます）')) {
            this.reloadWebApp();
          }
        } finally {
          this.setWaiting(false);
        }
      },
      deleteVisitRecord: async function(visitRecord, checkPoint) {
        if(!confirm(`訪問記録を削除します。この操作は取り消しできません。`)) return;
        this.setWaiting();
        try {
          const res = await axios.delete('/record_visit', {data: {id: visitRecord.id}});
          if(res.data.status !== 'SUCCESS') throw new Error(res.data.message);
          console.log('deleteVisitRecord res: ', res);
          alert('訪問記録を削除しました。');
          this.userData.visit_records = this.userData.visit_records.filter(record => record.id !== visitRecord.id);
          this.visitRecordShownVisitIndex--;
          if(this.visitRecordShownVisitIndex < 0) this.visitRecordShownVisitIndex = 0;
          this.$store.commit('deleteVisitRecord', {
            checkPoint: checkPoint,
            visitRecordToDelete: visitRecord,
          });
          this.courses.splice(0, 0);
          this.setRecordVisitButtonText(this.$store.state.selectedCheckPoint);
          this.closeEditRecordFormModal();

          // const tempSelectedCourse = this.selectedCourse;
          // const tempSelectedCheckPoint = this.$store.state.selectedCheckPoint;
          // this.selectedCourse = null;
          // this.$store.commit('setSelectedCheckPoint', null);
          // console.log('deleteVisitRecord checkPoint: ', checkPoint, this.$store.state.selectedCheckPoint, this.$store.state.selectedCourse);
          // this.visitRecordShownVisitIndex--;
          // if(this.visitRecordShownVisitIndex < 0) this.visitRecordShownVisitIndex = 0;
          // checkPoint.visits = checkPoint.visits.filter(record => record.id !== visitRecord.id);
          // this.courses.splice(0, 0);
          // this.selectedCourse = tempSelectedCourse;
          // this.$store.commit('setSelectedCheckPoint', tempSelectedCheckPoint);
          // this.setRecordVisitButtonText(tempSelectedCheckPoint);

          // this.checkPointToRecord.visits.push(newRecord);
          // this.courses.splice(0, 0);
          // this.setRecordVisitButtonText(this.checkPointToRecord);
          // this.closeRecordFormModal();
        } catch(error) {
          alert('訪問記録を削除できませんでした。');
          console.error(error);
          if(confirm('Webアプリを再読込するとうまくいくかもしれません。再読込しますか？')) {
            this.reloadWebApp();
          }
        } finally {
          this.setWaiting(false);
        }
      },
      openUserProfileModal: function() {
        if(!this.userProfileModal) {
          this.userProfileModal = new Modal(document.getElementById('userProfileModal'), {
            keyboard: false
          });
          $('#userProfileModal').off('shown.bs.modal').on('shown.bs.modal', () => {
            $('#userProfileModal').removeClass('noTransition');
          });
        }
        this.userProfileModal.show();
        this.collapseNaviBarMenu();
        // $('#visitRecordModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
        // });
      },
      closeUserProfileModal: function() {
        this.userProfileModal.hide();
      },
      genderDisplay: function(gender) {
        if(typeof this === 'undefined' || typeof this.globalAppData === 'undefined') return gender;
        const options = this.globalAppData?.user_profile_options?.gender_options;
        if(!options) return gender;
        for(const [key, value] of Object.entries(options)) {
          if(value === gender) return key;
        }
        return gender;
      },
      openEditUserProfileModal: function() {
        // Object.keys(this.userProfileForm).forEach(key => {
        //   this.userProfileForm[key] = this.userData[key];
        // });
        this.userProfileForm = Object.assign({}, this.userData);
        this.user_name_unique = true;
        this.user_name_unique_checked = false;
        if(!this.editUserProfileModal) {
          this.editUserProfileModal = new Modal(document.getElementById('editUserProfileModal'), {
            keyboard: false
          });
        }
        this.editUserProfileModal.show();
        this.userProfileModal.hide();
        $('#editUserProfileModal').off('hide.bs.modal').on('hide.bs.modal', () => {
          $('#userProfileModal').addClass('noTransition');
          this.userProfileModal.show();
        });
      },
      closeEditUserProfileModal: function() {
        this.editUserProfileModal.hide();
      },
      updateUserProfile: async function() {
        console.log('updateUserProfile called.');
        this.setWaiting();
        try {
          const res = await axios.put('/user_profile', this.userProfileForm);
          console.log('updateUserProfile res: ', res);
          if(res.data.status !== 'SUCCESS') throw new Error(res.data.error || res.data.errors || res.data.message);
          Object.assign(this.userData, this.userProfileForm);
          alert('ユーザープロファイルを更新しました。');
        } catch(error) {
          alert('ユーザープロファイルを更新できませんでした。');
          console.error(error);
          if(confirm('Webアプリを再読込するとうまくいくかもしれません。再読込しますか？（現在の入力内容は破棄されます）')) {
            this.reloadWebApp();
          }
        } finally {
          this.setWaiting(false);
        }
      },
      textLengthBytes: function(text) {
        return encodeURIComponent(text).replace(/%../g,'x').length;
      },
      confirmNameUnique: async function() {
        this.setWaiting();
        try {
          const res = await axios.get('/name_unique', {params: {name: this.userProfileForm.name}});
          console.log('confirmNameUnique res: ', res);
          if(res.data.status !== 'SUCCESS') throw new Error(res.data.error || res.data.errors || res.data.message);
          this.user_name_unique = res.data.is_unique;
          this.user_name_unique_checked = true;
        } catch(error) {
          alert('ニックネームを検証できませんでした。');
          this.user_name_unique_checked = false;
          console.error(error);
        } finally {
          this.setWaiting(false);
        }
      },
      parseSettingData: function(json) {
        const data = JSON.parse(json.replace(/(\n)/g, '\\n'));
        Object.keys(data).forEach(key => {
          if(!data[key]) data[key] = true;
          else if(data[key] === 'false') data[key] = false;
        });
        return data;
      },
    },
    created: function() {
      // let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
      // for (let i = 0, len = chars.length; i < len; i++) {
      //     switch (chars[i]) {
      //         case "x":
      //             chars[i] = Math.floor(Math.random() * 16).toString(16);
      //             break;
      //         case "y":
      //             chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
      //             break;
      //     }
      // }
      // this.eventMessageKey = chars.join('');
      // const data = {
      //   message: "iznvRequestReloadWebApp",
      //   url: window.location.href,
      //   key: this.eventMessageKey,
      //   referrer: document.referrer,
      // };
      // if(window !== window.parent) window.parent.postMessage(data, "*");
    },
    mounted: function() {
      $(window).on("message", e => {
        if(e.originalEvent.data.message === "iznvRequestReloadWebApp") {
          console.log('iznvRequestReloadWebApp message received. originalEvent.data: ', e.originalEvent.data);
          if(e.originalEvent.data.href) {
            const targetHref = e.originalEvent.data.href;
            const targetOrigin = new URL(targetHref)?.origin;
            const origins = this.globalAppData.available_series.map(series => {
              if(series.url) return new URL(series.url).origin;
              else return null;
            });
            console.log('iznvRequestReloadWebApp message domains: ', origins, targetOrigin);
            const targetSeries = this.globalAppData.available_series.find(series => {
              if(!series.url || !targetOrigin) return false;
              return new URL(series.url).origin === targetOrigin;
            });
            if(!targetSeries) {
              alert("このリンクは開けません。");
              return;
            }
            // if(!targetOrigin || !origins.includes(targetOrigin)) {
            //   alert("このリンクは開けません。");
            //   return;
            // }
            console.log('iznvRequestReloadWebApp message targetSeries.id: ', targetSeries.name, targetSeries.id, this.seriesData.id);
            const confirmationString = (targetSeries.id === this.seriesData.id) ? "シリーズを再読み込みしますか？" : "シリーズを" + targetSeries.name + "に切り替えますか？";
            if(confirm(confirmationString)) window.location.href = e.originalEvent.data.href;
          } else {
            alert("このリンクは開けません。");
          }
        //   if(e.originalEvent.origin !== window.origin) {
        //     console.log('iznvRequestReloadWebApp message received. originalEvent.origin: ', e.originalEvent.origin);
        //     return;
        //   }
        //   const reloadUrl = e.originalEvent.data.url;
        //   if(confirm("シリーズを再読み込みしますか？")) window.location.href = reloadUrl;
        //   else {
        //     e.originalEvent.source.postMessage({
        //       message: "iznvRequestReloadWebAppRefused",
        //       key: e.originalEvent.data.key,
        //     }, '*');
        //   }
        // } else if(e.originalEvent.data.message === "iznvRequestReloadWebAppRefused") {
        //   if(e.originalEvent.data.key === this.eventMessageKey) {
        //     window.location.href = document.referrer;
        //   }
        }
      });
      console.log('web_app mounted!');
      const thisYear = new Date().getFullYear();
      for(let y = 0; y < 100; y++) {
        this.birthYearOptions.push(thisYear - y);
      }
      this.defaultBirthYear = thisYear - 20;
      $('#visitRecordDateTimePicker')
      .on('change.datetimepicker', e => {
        console.log('datetimepicker changed.', e);
        this.editVisitRecordFormDateString = e.date;
      })
      .datetimepicker({
        icons: {
          time: 'far fa-clock',
          date: 'far fa-calendar-alt',
          up: 'fas fa-angle-up',
          down: 'fas fa-angle-down',
          previous: 'fas fa-chevron-circle-left',
          next: 'fas fa-chevron-circle-right',
          today: 'far fa-calendar-check',
          clear: 'fas fa-trash-alt',
          close: 'fas fa-times'
        },
        locale: 'ja',
        format: this.dateTimeFormat,
        dayViewHeaderFormat: this.dayViewHeaderFormat,
        ignoreReadonly: true,
        keepOpen: false,
      });
      $('#visitRecordDateTimePickerButton').on('click', (e) => {
        $('#visitRecordDateTimePicker').datetimepicker('toggle');
        e.stopPropagation();
      });
      $('#editRecordFormModal').on('click', () => {
        $('#visitRecordDateTimePicker').datetimepicker('hide');
      });
      if(typeof globalAppData !== 'undefined' && globalAppData.length) this.globalAppData = JSON.parse(globalAppData.replace(/(\n)/g, '\\n'));
      if(typeof userData !== 'undefined' && userData.length) this.userData = JSON.parse(userData.replace(/(\n)/g, '\\n'));
      if(typeof displayOptions !== 'undefined' && displayOptions.length) this.displayOptions = this.parseSettingData(displayOptions);
      console.log('userData, globalAppData, displayOptions: ', this.userData, this.globalAppData, this.displayOptions);
      this.loadAppData();
      if(typeof courseIndex !== 'undefined') {
        const index = parseInt(courseIndex);
        if(index > 0) this.courseIndex = index;
      }
      if(typeof checkPointId !== 'undefined') this.urlParams.checkPointId = checkPointId;
      this.start();
      // if(typeof googleMapKey !== 'undefined') {
      //   console.log("on mounted function googleMapKey: ", googleMapKey)
      //   window.mapApiLoaded = this.start;
      //   if(typeof google === 'undefined') {
      //     const scriptElement = document.createElement('script')
      //     scriptElement.src = `https://maps.googleapis.com/maps/api/js?language=ja&key=${googleMapKey}&libraries=places,geometry&callback=mapApiLoaded`;
      //     scriptElement.async = true;
      //     document.body.appendChild(scriptElement);
      //     console.log("scriptElement: ", scriptElement);
      //   } else {
      //     this.start();
      //   }
      // }
    }
  })
})
